import React, { useEffect, useState } from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { COLORS, GAME_STATES } from '../../../js/ids';
import SGMSClient from '../../../js/SGMSClient';
import Translations from '../../../js/Translations';
import { store } from '../../../stores/store';
import './MyScores.css';


function generateTtipContent(data) {
  // console.log("data", data)
  return (
  <div className="ttip">
    <div className="ttip-title">{store.t("myscores_chart_year")} {data.label}</div>

    {data.payload.map(p => (
      <div
      className="data"
      key={p.dataKey}
      style={{color: p.color, fontWeight: p.dataKey === data.currentKey ? "bold" : "normal"}}
      dangerouslySetInnerHTML={{__html: p.name + data.separator + p.value + (p.unit || "")}} />
    ))}

  </div>
)

}


const MyScores = () => {
  const [error, setError] = useState(false);


  const [myScores, setMyScores] = useState(null);

  const [limit, setLimit] = useState(1);

  function handleFilterChange(e) {
    setLimit(parseInt(e.target.value))
  }

  useEffect(() => {
    SGMSClient.meetingGetEventScores(SGMSClient.currentMeeting._id, SGMSClient.currentUser._id)
    .then(data => setMyScores(data))
    .catch(() => setError(true))
  }, []);



  let score_ind_key = "indT47"


  // 1- on réunit les scores par parties
  let games = []
  let currentGame = null

  if(myScores) {
    myScores.forEach(score => {

      if(score.indYearNumber === "1") {
        // nouvelle partie : on push l'ancienne
        if(currentGame) games.push(currentGame)
        // on en recrée une nouvelle
        currentGame = {num: games.length + 1, data:[]}
      }
      currentGame.data.push(score)
    })

    // vire les jeux qui n'ont qu'une année pour pas polluer
    games = games.filter(g => g.data.length > 1)

    // sauf pour le dernier qui reste
    games.push(currentGame) // le dernier
    if(limit > 0) games = games.slice(-limit)
  }

  let key_year = store.t("myscores_chart_year")
  let key_game = store.t("myscores_chart_game")

  // 2- on regroupe par années en créant une "key" pour chaque score
  let scores = []
  games.forEach(game => {

    game.data.forEach((yearScores, yearIndex) => {
      if(scores[yearIndex] === undefined) scores[yearIndex] = {[key_year]: key_year + " " + (yearIndex + 1)}
      scores[yearIndex][key_game + " " + game.num] = parseInt(yearScores[score_ind_key])
    })
  })

  let currentKey = key_game + " " + (games[games.length-1] ? games[games.length-1].num : "")

  if(myScores === null) return <div className="MyScores">{store.t("loading")}</div>
  if(myScores === undefined || scores.length === 0) return <div className="MyScores">{store.t("scores_no_data")}</div>
  if(error) return <div className="MyScores">{store.t("meeting_datas_error")}</div>

  return (
    <div className="MyScores">

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={scores} margin={{ top: 25, right: 5, bottom: 5, left: 25 }}>
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey={key_year}/>
          <YAxis />
          <Tooltip content={generateTtipContent} separator={Translations.chartSeparator} currentKey={currentKey} />

          {Object.keys(scores[0])
          .filter(k => k !== key_year)
          .map((key, i) =>  {
            let current = key === currentKey
            return (<Line
            key={i}
            dataKey={key}
            stroke={COLORS[i]}
            strokeWidth={current ? 4 : 1}
            activeDot={{r: 8}} />)
          })}

          <Legend />

        </LineChart>
      </ResponsiveContainer>
      <div className="filter" >
        <label ><input type="radio" name="limit" onChange={handleFilterChange} checked={limit === -1} value={-1} /> {store.t("my_score_show_all")}</label>
        <label ><input type="radio" name="limit" onChange={handleFilterChange} checked={limit === 5} value={5} /> {store.t("my_score_show_last_five")}</label>
        <label ><input type="radio" name="limit" onChange={handleFilterChange} checked={limit === 1} value={1} /> {store.t("my_score_show_last")}</label>
      </div>
    </div>
  );
};

export default MyScores;
